import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { cancelPendingPoint } from '../../../api/utils/api/purchaseApi';
import { selectPurchaseInfo } from '../../../store/features/purchaseSlice';
import { useAppSelector } from '../../../store/hook';

/**
 * 결제 실패 페이지
 * @description 토스 포함 모든 결제 실패 시 해당 페이지로 리다이렉션함
 * @url_params code: 결제 실패 코드
 * @url_params message: 결제 실패 메시지
 * @url_params orderId: 결제 실패 주문 ID
 * @example /commerce/purchase/fail?code=PAYMENT_FAILED&message=결제에 실패했습니다.&orderId=1234567890
 */
const PurchaseFail = () => {
  const navigate = useNavigate();
  const query = new URLSearchParams(useLocation().search);
  const code = query.get('code') as string;
  const message = query.get('message') as string;
  const orderId = query.get('orderId') as string;
  const purchaseInfo = useAppSelector(selectPurchaseInfo);

  useEffect(() => {
    if (orderId) {
      cancelPendingPoint(orderId);
    }
  }, [orderId]);

  /** 뒤로가기 핸들러 : 이전 템플릿 결제 페이지로 이동*/
  const handleGoBack = () => {
    navigate('/purchase', { state: { purchaseId: purchaseInfo?.id } });
  };

  return (
    <>
      <div className="mx-auto flex w-full max-w-[480px] flex-col items-center gap-4 bg-white p-5">
        <p className="text-xl font-bold text-gray-800">결제에 실패했습니다</p>
        <div className="relative h-[160px] w-[160px] shrink-0">
          <img
            className="h-full w-full object-contain"
            alt="결제 실패 아이콘"
            src={process.env.PUBLIC_URL + '/svg/icon/alert-triangle.svg'}
          />
          {/* <img
            className="h-full w-full object-contain"
            alt="결제 실패 아이콘"
            src={
              process.env.PUBLIC_URL +
              '/images/student/jebs-ai-recitation/result/fail_v2.svg'
            }
          /> */}
        </div>
        {/* 결제 실패 메시지 */}
        <p className="text-base text-gray-600">
          에러메세지 : {message ?? '결제에 실패했습니다.'}
        </p>
        {/* 결제 실패 코드 */}
        <p className="text-sm text-gray-400">
          에러 코드 : [{code ?? 'UNKNOWN_ERROR'}]
        </p>
        <button
          className="mt-4 items-center justify-center rounded bg-purple5 px-6 py-2 text-white"
          onClick={handleGoBack}
        >
          다시 결제하기
        </button>
      </div>
    </>
  );
};

export default PurchaseFail;
